export default {
    methods: {
        numberWithDot(number) {
            if ((number===null) || (number==='')) {
                return number;
            }
            const parts = number.toString().split('.');
            parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return parts.join(',');
        },
        checkFeatureByAcl(user, module, func) {
            // console.log('user')
            // console.log(user)
            // console.log('module')
            // console.log(module)
            // console.log('func')
            // console.log(func)
            if (user && user.role && user.role.label === 'superadmin') {
                // console.log('masuk superadmin')
                return true
            } else {
                // console.log('masuk !superadmin')
                let funcArr = []
                try {
                    let moduleACL = user.role.module.filter(function(item) {
                        return item.label.toUpperCase() === module.toUpperCase();
                    });
                    // console.log('moduleACL')
                    // console.log(moduleACL)
                    if (func == null) {
                        funcArr = moduleACL
                    } else {                        
                        funcArr = moduleACL[0].function.filter(function(item) {
                            return item.name.toUpperCase() === func.toUpperCase();
                        });
                    }
                    // console.log('funcArr')
                    // console.log(funcArr)
                } catch (error) {
                    console.log('error checkFeatureByAcl')
                    console.log(error)
                }
                return funcArr.length? true : false
            }
        },
    },
    filters: {
    },
};
